// The ONE shared, React-free formatter for a contribution's payment method at the
// read boundary. Sibling of `contributionTypeLabel` / `electionDesignationLabel`:
// a pure map so the compound PascalCase identifiers (`CreditCard`, `InKind`) never
// render verbatim. Takes a lenient `string` (like `electionDesignationLabel`) so a
// wire value outside the enum passes through unchanged rather than rendering empty.

import { PaymentMethod } from '../generated/enums.gen';

/** Per-method treasurer-first label, keyed by the wire enum value. */
export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  [PaymentMethod.Cash]: 'Cash',
  [PaymentMethod.Check]: 'Check',
  [PaymentMethod.CreditCard]: 'Credit card',
  [PaymentMethod.Wire]: 'Wire transfer',
  [PaymentMethod.InKind]: 'In-kind',
  [PaymentMethod.Other]: 'Other',
};

/**
 * Resolves the treasurer-first display label for a payment method. Falls back to the
 * raw value for any unexpected (non-enum) input so the boundary never renders empty.
 */
export function paymentMethodLabel(method: string): string {
  return PAYMENT_METHOD_LABELS[method as PaymentMethod] ?? method;
}
